"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    vehicle: {
        en: "Vehicle",
        es: "Vehiculo",
    },
    general: {
        en: "General",
        es: "General",
    },
    showTraffic: {
        en: "Show traffic",
        es: "Mostrar Trafico",
    },
    trace: {
        en: "Track view",
        es: "Mostrar rastro",
    },
    centerSelect: {
        en: "Center on select",
        es: "Centrar al seleccionar",
    },
    centerUpdate: {
        en: "Center on update",
        es: "Centrar al actualizar",
    },
    colorTrace: {
        en: "Trace",
        es: "Rastro",
    },
    colorMovement: {
        en: "Vehicle on movement",
        es: "Vehiculo en movimiento",
    },
    colorParcking: {
        en: "Vehicle parked",
        es: "Vehiculo estacionado",
    },
    colorIdle: {
        en: "Vehicle idle",
        es: "Vehiculo en Ocio",
    },
    mute: {
        en: "Sound",
        es: "Sonido",
    },
    notification: {
        en: "Notification",
        es: "Notificaciones",
    },
    en: {
        en: "English",
        es: "English",
    },
    es: {
        en: "Español",
        es: "Español",
    },
    METRIC: {
        en: "Metric",
        es: "Métrico",
    },
    USCUSTOM: {
        en: "Imperial",
        es: "Inglés",
    },
    roadmap: {
        en: "Map",
        es: "Mapa",
    },
    terrain: {
        en: "Terrain",
        es: "Relieve",
    },
    satellite: {
        en: "Satellite",
        es: "Satélite",
    },
    hybrid: {
        en: "Labels",
        es: "Etiquetas",
    },
    traceColorBySpeed: {
        en: "Trace color by speed range",
        es: "Color del rastro por rango de velocidades ",
    },
    configError: {
        en: "Equal ranges are not allowed",
        es: "No se permiten rangos iguales",
    },
    showTraceBySpeed: {
        en: "Trace by speed",
        es: "Rastro por velocidad",
    },
    clousterDevices: {
        en: "Cluster Units",
        es: "Agrupar unidades",
    },
    notificationSettings: {
        en: "Notification settings",
        es: "Ajuste de notificaciones",
    },
    desktopNotifications: {
        en: "Desktop notifications",
        es: "Notificaciones de escritorio",
    },
    bannerStyle: {
        en: "Banner style",
        es: "Estilo de tira",
    },
    speedSettings: {
        en: "Speed settings",
        es: "Ajustes de velocidad",
    },
    setSpeedLimit: {
        en: "Speed limit",
        es: "Limite de velocidad",
    },
    defineVehicleSpeed: {
        en: "Set the speed limit of the vehicle",
        es: "Establezca el limite de velocidad del vehículo"
    },
};
exports.default = translations;
